import { computed, makeAutoObservable, runInAction } from 'mobx'
import { deleteCookie } from '@utils/Cookies'
import { clearPersistedStore, makePersistable } from 'mobx-persist-store'
import {
  postUserLogin,
} from '@services/api/userAPI'
import {IUser, AccessRole} from '../types/AuthTypes'

class AuthStore {

  /**
   * Current logged-in user
   */
  user: IUser | null = null

  /**
   * Whether the user has called the /login endpoint for logging
   */
  loginLogged = false

  constructor() {
    makeAutoObservable(this, {
      userAccess: computed,
      isAuthenticated: computed
    })
    makePersistable(this, {
      name: 'AuthStore',
      properties: ['user'],
      storage: window.localStorage,
    })
  }

  get userAccess() : AccessRole {
    return this?.user?.accessRoleId ?? AccessRole.NoAccess
  }

  get isAuthenticated() : boolean {
    return this.user !== undefined && this.user !== null
  }

  setUser(user: IUser | null) {
    runInAction(() => (this.user = user))
  }

  setUserSSO = async (aInUser: IUser) => {
    this.setUser(aInUser)

    if (!this.loginLogged) {
      this.loginLogged = true
      const response = await postUserLogin()
      if (response.status !== 200) {
        this.loginLogged = false
      }
    }
  }

  async logout() {
    this.setUser(null)
    deleteCookie('id')
    await clearPersistedStore(this)
    return true
  }
}

export default AuthStore
